import { VehicleShopType } from '~/shared';
import elite from '../../assets/images/logo/elite.svg';
import low from '../../assets/images/logo/low.svg';
import middle from '../../assets/images/logo/middle.svg';
import specialVehicle from '../../assets/images/logo/spec_vehs.svg';

export const shopLogoByType = {
	[VehicleShopType.LOW]: low,
	[VehicleShopType.REGULAR]: middle,
	[VehicleShopType.EXPENSIVE]: elite,
	[VehicleShopType.WORK]: specialVehicle,
};
